/**
 * Shared helpers for tile render fns. These are formatting / labeling
 * concerns that span multiple stat tiles — keeping them in one place
 * lets each per-tile module stay tight on its own logic.
 */

export function pct(value: number): string {
  return `${(value * 100).toFixed(0)}%`;
}

/**
 * Window label rendered next to each stat tile's ▲/▼ delta. The
 * dashboard date filter passes a preset name through to tiles via the
 * dashboardCtx; we reformat to "vs prior <window>" — e.g. "Last 30 days"
 * → "vs prior 30d". Keeps the badge tight at small tile sizes.
 */
export function priorPeriodLabel(preset: string): string {
  if (preset.startsWith('Last 7 days')) return 'vs prior 7d';
  if (preset.startsWith('Last 30 days')) return 'vs prior 30d';
  if (preset.startsWith('Last 90 days')) return 'vs prior 90d';
  if (preset === 'This month') return 'vs prior month';
  return 'vs prior period';
}
